import React, { Component } from "react";
import { Table, DatePicker, Button, Select, Tooltip, message, Spin } from 'antd'
import moment from 'moment'
import { getExamItem, getSearchPartFirstData, getSearchPartSecondData, GetTableHeaderData, getConsultationList, GetExportPackageData, getGroupExamSubList, getGroupExamItemList, } from '@/request/api'

import { uniqueJsonArrByField,requestErrorLog } from '@/common/util'
const { Option } = Select;

class PackageCheckList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkTypeList: [],
      checkedType: [],
      selectPriceDate: '',
      offsetDays: 31536000000 * 5,
      checkType: [],
      checkSubclass: [],
      checkProject: [],
      searchTime: '',
      packageHospitalData: [],//套餐检查量机构列表
      packagePersonData: [],//套餐检查量医生列表
      groupingArr: [],
      firstGroupList: [],
      secondGroupList: [],
      consultHospitalList: [],
      firstGroupValue: [],
      secondGroupValue: [],
      userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},

      startDate: moment().startOf('month'),
      endDate: moment().endOf("day"),
      firstGroupName: [],
      secondGroupName: [],
      isLoading: false,
      isExportLoading: false,
    }
  }

  async componentDidMount() {
    this.allBasicData();
    let firstGroupList = [], secondGroupList = []
    let res = await getSearchPartFirstData('E00113', this.state.userInfo.HOSPITAL_CODE);
    if (res && res.Status === 1) {
      firstGroupList = res.Result ? res.Result : []
    }else {
      requestErrorLog('', '数据统计-套餐检查量统计获取一级分组报错', 0,true)
    }
    //二次需求：一级分组为空也请求二级分组列表
    let firstArr = firstGroupList.map(obj => obj.FIRST_GROUP_CODE)
    let secondRes = await getSearchPartSecondData("E00113", this.state.userInfo.HOSPITAL_CODE, firstArr.toString())
    if (secondRes && secondRes.Status === 1) {
      secondGroupList = secondRes.Result ? secondRes.Result : []
    }else {
      requestErrorLog('', '数据统计-套餐检查量统计获取二级分组报错', 0,true)
    }
    secondGroupList =uniqueJsonArrByField(secondGroupList, 'SECOND_GROUP_NAME')
    this.setState({
      firstGroupList,
      secondGroupList,
    }, () => {
      this.searchData()
    })
  }
  //获取检查类型、检查子类、检查项目基础数据
  allBasicData = () => {
		let userInfo = JSON.parse(localStorage.getItem("userInfo"));
		if (!userInfo) return;
		let id = userInfo.HOSPITAL_UID;
    getExamItem(id).then((res) => {
      if (res && res.Status === 1) {
        let allData = []
        let checkType = []
        for (let i = 0; i < res.Result.length; i++) {
          if (res.Result[i].id === 'BloodPressure') {
            allData.push(res.Result[i])
            checkType.push({
              id: res.Result[i].id,
              name: res.Result[i].name,
            })
          }
          if (res.Result[i].id === 'ECG') {
            allData.push(res.Result[i])
            checkType.push({
              id: res.Result[i].id,
              name: res.Result[i].name,
            })
          }
          if (res.Result[i].id === 'Holter') {
            allData.push(res.Result[i])
            checkType.push({
              id: res.Result[i].id,
              name: res.Result[i].name,
            })
          }
        }
        this.setState({
          allData,
          checkType,
        })
      }else {
        requestErrorLog('', '数据统计-套餐检查量统计获取检查类型、检查子类、检查项目基础数据报错', 0,true)
      }
    })
  };
  //一级组别变化
  firstGroupChange = async (firstGroupData) => {
    let firstGroupName = firstGroupData.length > 0 ? this.state.firstGroupList.filter(item => firstGroupData.indexOf(item.FIRST_GROUP_CODE) > -1).map(item => { return item.FIRST_GROUP_NAME }) : []
    //二次需求：一级分组为空也请求二级分组列表
    let firstArr = this.state.firstGroupList.map(obj => obj.FIRST_GROUP_CODE)
    let secondGroupList = firstGroupData.length > 0 ? await this.secondList(firstGroupData) : await this.secondList(firstArr)
    if (!firstGroupData.length > 0) {
      secondGroupList =uniqueJsonArrByField(secondGroupList, 'SECOND_GROUP_NAME')
    }
    let stateObject = {
      firstGroupName,
      secondGroupName: [],
      firstGroupValue: firstGroupData.length > 0 ? firstGroupData : [],
      secondGroupValue: undefined,
      secondGroupList,
      consultHospitalList: [],
      consultHospitalValue: '',
    }
    this.setState(stateObject);
  };
  //获取二级分组列表
  secondList = async (firstGroupData) => {
    let res = await getSearchPartSecondData("E00113", this.state.userInfo.HOSPITAL_CODE, firstGroupData.toString())
    if (res && res.Status === 1) {
      return res.Result ? res.Result : []
    } else {
      requestErrorLog('', '数据统计-套餐检查量统计获取二级分组报错', 0,true)
      return []
    }
  }
  //获取当前登录医院的会诊医院列表
  getConsultationList = async (FIRST_GROUP_CODE, SECOND_GROUP_CODE) => {
    let res = await getConsultationList(this.state.userInfo.HOSPITAL_CODE, FIRST_GROUP_CODE.toString(), SECOND_GROUP_CODE.toString())
    if (res && res.Status === 1) {
      return res.Result ? res.Result : []
    } else {
      requestErrorLog('', '数据统计-套餐检查量统计获取当前登录医院的会诊医院列表报错', 0,true)
      return []
    }

  }
  //二级组别变化
  secondGroupChange = async (secondGroupData) => {
    if (this.state.firstGroupValue.length > 0) {
      let consultHospitalList = secondGroupData.length > 0 ? await this.getConsultationList(this.state.firstGroupValue, secondGroupData) : []
      let secondGroupName = secondGroupData.length > 0 ? this.state.secondGroupList.filter(item => secondGroupData.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => { return item.SECOND_GROUP_NAME }) : []
      this.setState({
        secondGroupName,
        secondGroupValue: secondGroupData,
        consultHospitalList,
        consultHospitalValue: '',
      })
    } else {
      let secondGroupName = secondGroupData.length > 0 ? this.state.secondGroupList.filter(item => secondGroupData.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => { return item.SECOND_GROUP_NAME }) : []
      this.setState({
        secondGroupName,
        secondGroupValue: secondGroupData,
      })
    }
  }
  //会诊机构变化
  consultHospitalChange = (consultHospitalValue) => {
    this.setState({
      consultHospitalValue,
    })
  }
  //选择检查类型
  changeCheckType = async (id) => {
    let checkSubclass = []
    if (id !== '') {
      let Param = {
        Type: "GetExam_SubList",
        EXAM_CLASS: id//检查类型
      }
      let res = await getGroupExamSubList(Param)
      if (res && res.Status === 1) {
        checkSubclass = res.Result ? res.Result : []
      }else{
        requestErrorLog('', '数据统计-套餐检查量统计获取检查子类报错', 0,true)
      }

      this.setState({
        checkTypeID: id,
        checkSubclass,
        checkSubclassID: '',
        checkProjectID: '',
        checkProject: [],
      })
    }
    else {
      this.setState({
        checkTypeID: id,
        checkSubclass,
        checkProject: [],
        checkSubclassID: '',
        checkProjectID: '',
      })
    }
  }
  //选择检查子类
  changeCheckSubclass = async (id) => {
    let checkProject = []
    if (id !== '') {
      let Param = {
        Type: "GetExam_ItemList",
        EXAM_CLASS: this.state.checkTypeID,//检查类型
        EXAM_SUB: id.split('&')[0]//检查子类（自定义查询页面可不传）
      }
      let res = await getGroupExamItemList(Param)
      if (res && res.Status === 1) {
        checkProject = res.Result ? res.Result : []
      }else{
        requestErrorLog('', '数据统计-套餐检查量统计获取检查项目报错', 0,true)
      }
      this.setState({
        checkProject,
        checkSubclassID: id,
        checkProjectID: '',
      })
    }
    else {
      this.setState({
        checkProject,
        checkSubclassID: id,
        checkProjectID: '',
      })
    }
  }
  //选择检查项目
  changeCheckProject = (id) => {
    this.setState({
      checkProjectID: id,
    })
  }
  //勾选查询条件需要重新查表头以及表数据
  searchData = async () => {
    this.setState({
      isLoading: true
    }, async () => {
      let packageColumns = await this.getPackageTableData('header');
      this.setState({
        packageColumns,
      }, () => {
        if (this.state.packageColumns.length > 0) {//如果表头没有返回数据，就不请求表数据
          this.getPackageTableData('data');
        }
      })
    })

  }
  //获取套餐检查量表头和数据type：区别表头和表数据；consultHospitalList：接口必须传医院code，如果没选，传第一项；
  getPackageTableData = async (type) => {
    //获取检查项目套餐表头
    let packageColumns = [
    ]
    const { userInfo, checkTypeID, checkSubclassID, checkProjectID, startDate, endDate, consultHospitalValue, consultHospitalList } = this.state
    let searchTime = ''
    searchTime = moment(startDate).format('YYYY-MM-DD') + ' - ' + moment(endDate).format('YYYY-MM-DD')
    this.setState({
      searchTime,
    })

    let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''//一级分组
    let SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''//二级分组
    if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
      if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
        let secondGroupArr = SECOND_GROUP_CODE.split(',')
        SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
      } else {
        SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
      }
    }
    let packageParam = {
      Type: type === "header" ? "GetTableData" : 'GetDoctorPackageData',
      EXAM_CLASS: checkTypeID ? checkTypeID : '',//检查类型
      EXAM_SUB_CLASS: checkSubclassID?.split('&')[0] || '',//检查子类
      EXAM_ITEM: checkProjectID?.split('&')[0] || '',//检查项目
      HOSPITAL_CODE: consultHospitalValue ? consultHospitalValue : '',//所属医院
      APPLY_HOSPITAL_CODE: userInfo.HOSPITAL_CODE,//申请机构
      CONSULTATION_STATUS: '',//会诊状态
      EXAM_STATUS: '',//报告状态
      EXAM_DATETIME: [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')],//检查时间
      FIRST_GROUP_CODE,//一级分组
      SECOND_GROUP_CODE,//二级分组
    }
    let packageRes = await GetTableHeaderData('E00113', packageParam);
    let divWidth = document.getElementById('packageStatisticsTableBox')?.offsetWidth;
    let tableWidth = 200;//表格宽度如果占不满父级div ，宽度无效会被百分比撑开，固定列和table第一列宽度不一样，样式错乱
    if (type === 'header') {
      if (packageRes && packageRes.Status === 1) {
        let result = packageRes.Result;
        //会诊医院下拉列表选中数据、一级分组和二级分组共同选中数据、，都没选中时数据
        //更新查询内容，能查到会诊医院名称显示会诊医院名称，查不到显示code
        let hospitalName
        if (consultHospitalValue) {
          hospitalName = consultHospitalList.find(item => item.CONSULTATION_HOSPITAL_CODE === consultHospitalValue).CONSULTATION_HOSPITAL_NAME
        } else if (this.state.firstGroupValue?.length > 0 && this.state.secondGroupValue?.length > 0) {
          hospitalName = consultHospitalList.map(item => { return item.CONSULTATION_HOSPITAL_NAME }).toString()
        } else {

          hospitalName = packageRes.ResponseModel.map(item => { return item.CONSULTATION_HOSPITAL_NAME }).toString()
        }
        let typeChildren = [];
        let backgroundColorClass = ''
        for (let i = 0; i < result.length; i++) {
          if (result[i].EXAM_CLASS_CODE === 'ECG' || result[i].EXAM_CLASS_CODE === 'Holter' || result[i].EXAM_CLASS_CODE === 'BloodPressure') {
            let subArr = result[i].SUB_DATA
            let subChildren = []
            if (result[i].EXAM_CLASS_CODE === 'Holter') {
              backgroundColorClass = 'tableHeaderClass1'
            } else if (result[i].EXAM_CLASS_CODE === 'BloodPressure') {
              backgroundColorClass = 'tableHeaderClass2'
            }
            for (let j = 0; j < subArr.length; j++) {
              let projectArr = subArr[j].ITEM_DATA
              let projectChildren = []
              for (let k = 0; k < projectArr.length; k++) {
                let singleProject = {}
                singleProject = {
                  dataIndex: projectArr[k].ITEM_CODE,
                  key: projectArr[k].ITEM_CODE,
                  title: () => (
                    <span>
                      <Tooltip
                        title={projectArr[k].ITEM_NAME}
                      >
                        {projectArr[k].ITEM_NAME}
                      </Tooltip>
                    </span>
                  ),
                  width: 100,
                  ellipsis: true,
                  className: backgroundColorClass,
                  render: (text) => {
                    if (text) {
                      return text.toString()
                    }
                    else {
                      return 0
                    }
                  },
                }
                tableWidth += 100
                projectChildren.push(singleProject)
                //每个分类最后一行是横向合计
                if (j === subArr.length - 1 && k === projectArr.length - 1) {
                  let totalType = ''
                  if (projectArr[k].ITEM_CODE.indexOf('BloodPressure') > -1) {
                    totalType = 'BloodPressureTOTAL'
                  } else if (projectArr[k].ITEM_CODE.indexOf('ECG') > -1) {
                    totalType = 'ECGTOTAL'
                  } else if (projectArr[k].ITEM_CODE.indexOf('Holter') > -1) {
                    totalType = 'HolterTOTAL'
                  }
                  projectChildren.push({
                    dataIndex: totalType,
                    title: '合计',
                    width: 100,
                    ellipsis: true,
                    className: backgroundColorClass,
                    render: (text) => {
                      if (text) {
                        return text
                      }
                      else {
                        return 0
                      }
                    },
                  })
                  //计算每个分类加上合计列总长度
                  tableWidth += 100
                }

              }
              let singleArr = {
                title: () => (
                  <span>
                    <Tooltip
                      title={subArr[j].EXAM_SUB_CLASS}
                    >
                      {subArr[j].EXAM_SUB_CLASS}
                    </Tooltip>
                  </span>
                ),
                children: projectChildren,
                className: backgroundColorClass,
                width: 100,
                ellipsis: true,
              }
              subChildren.push(singleArr)
            }
            let singleType = {
              title: result[i].EXAM_CLASS,
              children: subChildren,
              className: backgroundColorClass
            }
            typeChildren.push(singleType)
          } else {
            continue;
          }
        }
        this.setState({
          tableWidth,
          consultHospitalName: hospitalName,
        })
        //计算如果表格长度超过展示长度，固定第一列，否则不需要
        if (tableWidth > divWidth) {
          packageColumns[0] = {
            title: "",
            fixed: 'left',
            className: checkTypeID ? backgroundColorClass : '',
            children: [
              {
                title: "",
                fixed: 'left',
                className: checkTypeID ? backgroundColorClass : '',
                children: [
                  {
                    title: "报告医生",
                    dataIndex: 'REAL_NAME',
                    width: '200px',
                    align: "center",
                    fixed: 'left',
                    className: checkTypeID ? backgroundColorClass : '',
                  },
                ]
              },
            ],
          }
        } else {
          packageColumns[0] = {
            title: "",
            className: checkTypeID ? backgroundColorClass : '',
            children: [
              {
                title: "",
                className: checkTypeID ? backgroundColorClass : '',
                children: [
                  {
                    title: "报告医生",
                    dataIndex: 'REAL_NAME',
                    width: '200px',
                    align: "center",
                    className: checkTypeID ? backgroundColorClass : '',
                  },
                ]
              },
            ],
          }
        }
        packageColumns = packageColumns.concat(typeChildren);
        return packageColumns
      } else {
        message.warn('获取检查项目失败')
        requestErrorLog('', '数据统计-套餐检查量统计获取检查项目报错', 0,true)
        this.setState({
          isLoading: false
        })
        return []
      }
    } else if (type === 'data') {
      if (packageRes && packageRes.Status === 1) {
        //处理数据，做一个竖向的合计
        let data = packageRes.Result ? packageRes.Result : [];
        let sumData = JSON.parse(JSON.stringify(data));
        let objSUM = {};
        // let sum = values.reduce((prev, cur, index, array) => prev + cur);
        let maxLength = 12
        if (sumData.length > 0) {
          objSUM = sumData.reduce((preRes, next,) => {
            if (!preRes) preRes = {}
            Object.keys(next).forEach((key) => {
              if (key !== 'HOSPITAL_CODE' && key !== 'HOSPITAL_NAME' && key !== 'REAL_NAME' && key !== 'USER_UID') {
                //返回的数据中有num和字符串，需转换
                if (next[key]) {
                  let nextKey = parseInt(next[key]);
                  preRes[key] = (preRes[key] ? parseInt(preRes[key]) : 0) + nextKey
                }
              }
              if (key === 'HOSPITAL_NAME' || key === 'REAL_NAME') {
                preRes[key] = preRes[key].length > next[key].length ? preRes[key] : next[key]
                maxLength = preRes[key].length > maxLength ? preRes[key].length : maxLength;
              }
            })
            return preRes
          })
        }
        if (sumData.length === 1) {
          if (sumData[0].HOSPITAL_NAME) {
            maxLength = sumData[0].HOSPITAL_NAME.length > maxLength ? sumData[0].HOSPITAL_NAME.length : maxLength
          }
          if (sumData[0].REAL_NAME) {
            maxLength = sumData[0].REAL_NAME.length > maxLength ? sumData[0].REAL_NAME.length : maxLength
          }
        }
        objSUM.USER_UID = 'heji'
        objSUM.REAL_NAME = '合计'
        data.push(objSUM);

        let backgroundColorClass = ''
        if (checkTypeID === 'Holter') {
          backgroundColorClass = 'tableHeaderClass1'
        } else if (checkTypeID === 'BloodPressure') {
          backgroundColorClass = 'tableHeaderClass2'
        }
        if (maxLength > 12) {
          maxLength = maxLength * 16//第一列宽度超过限制，表头会出现空白，超长处理ellipsis无效，所以需要重新处理Columns
          let packageColumns = this.state.packageColumns;
          //仍然需要计算表格总宽度是否占满父级div，用来判断第一列是否固定
          let tableWidth = this.state.tableWidth;
          tableWidth = tableWidth - 200 + maxLength
          if (tableWidth > divWidth) {
            packageColumns[0] = {
              title: "",
              fixed: 'left',
              className: backgroundColorClass,
              children: [
                {
                  title: "",
                  fixed: 'left',
                  className: backgroundColorClass,
                  children: [
                    {
                      title: "报告医生",
                      dataIndex: 'REAL_NAME',
                      width: maxLength,
                      align: "center",
                      fixed: 'left',
                      className: backgroundColorClass,
                    },
                  ]
                },
              ],
            }
            this.setState({
              packageColumns
            })
          } else {
            packageColumns[0] = {
              title: "",
              className: backgroundColorClass,
              children: [
                {
                  title: "",
                  className: backgroundColorClass,
                  children: [
                    {
                      title: "报告医生",
                      dataIndex: 'REAL_NAME',
                      width: maxLength,
                      align: "center",
                      className: backgroundColorClass,
                    },
                  ]
                },
              ],
            }
            this.setState({
              packageColumns
            })
          }
        } else {
          //不超过12个字，第一列宽度为200
          maxLength = 200//第一列宽度超过限制，表头会出现空白，超长处理ellipsis无效，所以需要重新处理Columns
          let packageColumns = this.state.packageColumns;
          let tableWidth = this.state.tableWidth;
          if (tableWidth > divWidth) {
            packageColumns[0] = {
              title: "",
              fixed: 'left',
              className: backgroundColorClass,
              children: [
                {
                  title: "",
                  fixed: 'left',
                  className: backgroundColorClass,
                  children: [
                    {
                      title: "报告医生",
                      dataIndex: 'REAL_NAME',
                      width: maxLength,
                      align: "center",
                      fixed: 'left',
                      className: backgroundColorClass,
                    },
                  ]
                },
              ],
            }
            this.setState({
              packageColumns
            })
          } else {
            packageColumns[0] = {
              title: "",
              className: backgroundColorClass,
              children: [
                {
                  title: "",
                  className: backgroundColorClass,
                  children: [
                    {
                      title: "报告医生",
                      dataIndex: 'REAL_NAME',
                      width: maxLength,
                      align: "center",
                      className: backgroundColorClass,
                    },
                  ]
                },
              ],
            }
            this.setState({
              packageColumns
            })
          }
        }
        this.setState({
          packagePersonData: data,
          isLoading: false,
        })
      } else {
        message.warn('获取检查项目失败')
        requestErrorLog('', '数据统计-套餐检查量统计获取检查项目报错', 0,true)
        this.setState({
          isLoading: false
        })
      }
    }
  }

  //选择开始时间
  setStartDate = (date) => {
    if (date) {
      this.setState({
        startDate: date,
      })
    } else {
      this.setState({
        startDate: '',
      })
    }
  }
  //选择结束时间
  setEndDate = (date) => {
    if (date) {
      this.setState({
        endDate: date,
      })
    } else {
      this.setState({
        endDate: '',
      })
    }
  }
  //导出
  exportPackageData = () => {
    this.setState({ isExportLoading: true }, () => {
      const { checkTypeID, checkSubclassID, checkProjectID, CONSULTATION_STATUS, EXAM_STATUS, startDate, endDate, consultHospitalValue, consultHospitalName, } = this.state
      //更新表头显示内容，能查到会诊医院名称显示会诊医院名称，查不到显示code
      let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''//一级分组
      let SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''//二级分组
      if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
        if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
          let secondGroupArr = SECOND_GROUP_CODE.split(',')
          SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
        } else {
          SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
        }
      }
      let exportParam = {
        Type: 'ExportPackageData',
        EXAM_CLASS: checkTypeID ? checkTypeID : '',//检查类型
        EXAM_SUB_CLASS: checkSubclassID?.split('&')[0] || '',//检查子类
        EXAM_ITEM: checkProjectID?.split('&')[0] || '',//检查项目
        HOSPITAL_CODE: consultHospitalValue ? consultHospitalValue : '',//所属医院

        APPLY_HOSPITAL_CODE: this.state.userInfo.HOSPITAL_CODE,//申请机构
        CONSULTATION_STATUS: CONSULTATION_STATUS ? CONSULTATION_STATUS : '',//会诊状态
        EXAM_STATUS: EXAM_STATUS ? EXAM_STATUS : '',//报告状态
        EXAM_DATETIME: [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')],//检查时间
        FIRST_GROUP_CODE,//一级分组
        SECOND_GROUP_CODE,//二级分组
        GROUP_TYPE: 1,//0：按照申请机构统计，1：按照审核医生统计
        HOSPITAL_NAME: consultHospitalName ? consultHospitalName : '',
        APPLY_HOSPITAL_NAME: this.state.userInfo.HOSPITAL_NAME,
      }
      GetExportPackageData('E00113', exportParam).then((res) => {
        if (res && res.Status === 1) {
          window.location.href = window.g.baseURL + "\\" + res.Result;
          this.setState({
            isExportLoading: false
          })
        } else {
          message.warn("导出失败")
          requestErrorLog('', '数据统计-套餐检查量统计导出报错', 0,true)
          this.setState({
            isExportLoading: false
          })
        }
      })
    })
  }
  render() {
    const { firstGroupName, secondGroupName, consultHospitalList, checkTypeID, checkType, checkSubclassID, checkSubclass, checkProjectID, checkProject, packageColumns, searchTime, firstGroupValue, secondGroupValue, packagePersonData } = this.state
    let firstGroupValueLength = '+' + firstGroupValue?.length
    let secondGroupValueLength = '+' + secondGroupValue?.length
    console.log(firstGroupValueLength, secondGroupValueLength)
    return (
      <>
        <div className="commonCase">
          <div className="datePickerBox" style={{ flexWrap: 'wrap' }}>
            <div className="wrapDiv">
              <span>检查时间：</span>
              <DatePicker
                style={{ width: 125 }}
                placeholder='开始日期'
                onChange={this.setStartDate}
                defaultValue={this.state.startDate}
                allowClear={false}
              />
              <span style={{ display: 'inline-block', textAlign: 'center', width: 15 }}>-</span>
              <DatePicker
                style={{ width: 125 }}
                placeholder='结束日期'
                onChange={this.setEndDate}
                defaultValue={this.state.endDate}
                allowClear={false}
              />
              <span className="institution">一级分组：</span>
              <Tooltip overlayClassName='tooltipColor' title={firstGroupName.toString()}>
                <Select
                  className='noWrapSelect'
                  mode="multiple"
                  maxTagCount={1}
                  maxTagPlaceholder={firstGroupValueLength}
                  maxTagTextLength={4}
                  value={firstGroupValue}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  style={{ width: "200px" }}
                  onChange={this.firstGroupChange}>
                  {this.state.firstGroupList.map((item,) => (
                    <Option key={item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE}>
                      {item.FIRST_GROUP_NAME}
                    </Option>
                  ))}
                </Select>
              </Tooltip>
              <span className="institution">二级分组：</span>
              <Tooltip overlayClassName='tooltipColor' title={secondGroupName.toString()}>
                <Select
                  className='noWrapSelect'
                  mode="multiple"
                  maxTagCount={1}
                  maxTagPlaceholder={secondGroupValueLength}
                  maxTagTextLength={4}
                  value={secondGroupValue}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  style={{ width: "200px" }}
                  onChange={this.secondGroupChange}>
                  {this.state.secondGroupList.map((item) => (
                    <Option key={item.SECOND_GROUP_CODE} value={item.SECOND_GROUP_CODE}>
                      {item.SECOND_GROUP_NAME}
                    </Option>
                  ))}
                </Select>
              </Tooltip>
            </div>
            <div className="wrapDiv">
              <span>会诊机构：</span>
              <Select
                value={this.state.consultHospitalValue}
                showSearch
                optionFilterProp="children"
                onChange={this.consultHospitalChange}
              >
                {consultHospitalList ? consultHospitalList.map((item) => (
                  <Option
                    key={item.CONSULTATION_HOSPITAL_CODE}
                    value={item.CONSULTATION_HOSPITAL_CODE}>
                    {item.CONSULTATION_HOSPITAL_NAME}
                  </Option>
                ))
                  : null}
              </Select>

              <span className="institution">检查类型：</span>
              <Select onChange={this.changeCheckType}
                value={
                  checkTypeID ? checkTypeID : ''
                }>
                <Option value="">全部</Option>
                {checkType.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
              <span className="institution">检查子类：</span>
              <Select onChange={this.changeCheckSubclass}
                value={
                  checkSubclassID ? checkSubclassID : ''
                }
              >
                <Option value="">全部</Option>
                {checkSubclass.map((item,) => (
                  <Option key={item.SUB_CLASS_CODE + '&' + item.SUB_CLASS_NAME} value={item.SUB_CLASS_CODE + '&' + item.SUB_CLASS_NAME}>
                    {item.SUB_CLASS_NAME}
                  </Option>
                ))}
              </Select>
              <span className="institution">检查项目：</span>
              <Select value={
                checkProjectID ? checkProjectID : ''
              }
                onChange={this.changeCheckProject}>
                <Option value="">全部</Option>
                {checkProject.map((item,) => (
                  <Option key={item.ITEM_CODE + '&' + item.ITEM_NAME} value={item.ITEM_CODE + '&' + item.ITEM_NAME}>
                    {item.ITEM_NAME}
                  </Option>
                ))}
              </Select>
              <Button className="loadButton" loading={this.state.isLoading} onClick={this.searchData}>查询</Button>
              <Button className="loadButton" loading={this.state.isExportLoading} onClick={this.exportPackageData}>导出</Button>
            </div>
          </div>
        </div>
        <div className="statisticsTableBox" id="packageStatisticsTableBox" style={{ minWidth: "1260px" }}>
          <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
            <Table
              columns={packageColumns}
              dataSource={packagePersonData}
              bordered
              pagination={false}
              scroll={{
                x: 1200,
                y: 500
              }}
              rowKey={(record, index) =>
                index
              } // 需要修改为唯一的ID！
              title={() => (
                <div className="tableHeader">
                  <p>{'会诊机构：'}{this.state.consultHospitalName}</p>
                  <p>
                    查询时间：{searchTime}
                  </p>
                </div>
              )}
            ></Table>
          </Spin>
        </div>
      </>
    );
  }
}

export default PackageCheckList;
